import { Input, NoticeBase } from "@synthesis/shared-ui";

import { CreateApplicationFormField, CreateApplicationFormRow, CreateApplicationFormSection } from "../create-application-form-layout";

export const CrossingObjectScheduleSection = () => (
  <CreateApplicationFormSection title="Сроки реализации">
    <NoticeBase
      status="info"
      titleAppearance="plain"
      title="Укажите планируемые сроки начала и завершения работ, если они известны. Допускается указание ориентировочных дат."
      description="Заполнение полей не является обязательным."
      className="max-w-none"
    />

    <CreateApplicationFormRow className="lg:grid-cols-3">
      <CreateApplicationFormField label="Планируемый срок начала работ">
        <Input name="implementationStartDate" placeholder="Например: II квартал 2028 г., сентябрь 2028 г." />
      </CreateApplicationFormField>

      <CreateApplicationFormField label="Планируемый срок завершения работ">
        <Input name="implementationEndDate" placeholder="Например: I квартал 2029 г., август 2029 г." />
      </CreateApplicationFormField>

      <CreateApplicationFormField label="Планируемый срок ввода в эксплуатацию">
        <Input name="commissioningDate" placeholder="Например: II квартал 2029 г., сентябрь 2029 г." />
      </CreateApplicationFormField>
    </CreateApplicationFormRow>
  </CreateApplicationFormSection>
);
